import { render } from "./AttachmentsList.vue?vue&type=template&id=6b0868e7&scoped=true"
import script from "./AttachmentsList.vue?vue&type=script&lang=js"
export * from "./AttachmentsList.vue?vue&type=script&lang=js"

import "./AttachmentsList.vue?vue&type=style&index=0&id=6b0868e7&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0868e7"]])

export default __exports__